import React, { useEffect, useState } from "react";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import Constants from "../../data/Constants";
import Utils from "../../utils/index";
import { isMobile } from "react-device-detect";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { getMentorsList } from "../../services/mentor.service";
import moment from "moment";

function Mentors(props) {
  const navigate = useNavigate();
  const [data, setData] = useState(false);
  const { setProgress, setToast, isRefreshed } = useOutletContext();

  useEffect(() => {
    setProgress(true);

    async function api() {
      try {
        const data = await getMentorsList();
        if (data) {
          setData(data);
          setProgress(false);
        } else {
          // error

          setProgress(false);
          setToast({ error: true, message: Constants.Error.UNKNOWN });
        }
      } catch (error) {
        // error

        setProgress(false);
        setToast({
          error: true,
          message: Utils.CustomErrorMessage(error),
        });
      }
    }
    api();
  }, [isRefreshed]);

  function CustomRow(props) {
    const { row, index, skipValue } = props;

    return (
      <>
        <TableRow key={row._id}>
          <TableCell>{index + 1 + skipValue}</TableCell>
          <TableCell>{row.firstname + " " + row.lastname}</TableCell>
          <TableCell>{row.profession}</TableCell>
          <TableCell>{row.education}</TableCell>
          {/* <TableCell>{row.slots}</TableCell> */}
          <TableCell>{row.counsellingPrice.salePrice}</TableCell>
          <TableCell>{row.balance}</TableCell>
          <TableCell>{row.deleted.toString()}</TableCell>
          <TableCell>
            {moment(row.createdAt).format("dddd, MMMM Do YYYY, h:mm a")}
          </TableCell>
          <TableCell>
            <Button
              size="small"
              onClick={(e) => {
                navigate("/dashboard/mentors/edit/" + row._id, {
                  state: { mentor: row },
                });
              }}
            >
              Edit
            </Button>

            <Button
              size="small"
              variant="contained"
              onClick={(e) => {
                navigate("/dashboard/mentors/" + row._id, {
                  state: { mentor: row },
                });
              }}
            >
              View
            </Button>
          </TableCell>
        </TableRow>
      </>
    );
  }

  return (
    <div>
      <Box style={{ width: "100%" }}>
        <TableContainer>
          <div className="flex justify-end gap-5">
            <Button
              variant="outlined"
              className="my-8"
              onClick={(e) => {
                navigate("/dashboard/mentors/edit");
              }}
            >
              Create Mentor
            </Button>
          </div>
          <Table size="small">
            <TableHead className="">
              <TableRow className=""></TableRow>
              <TableRow>
                <TableCell style={{ fontWeight: "bold" }}>ID</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Fullname</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Profession</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Education</TableCell>
                {/* <TableCell style={{ fontWeight: "bold" }}>Timing</TableCell> */}
                <TableCell style={{ fontWeight: "bold" }}>Price</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Balance</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Deleted</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Created At</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data
                ? data.map((row, index) => {
                    return (
                      <CustomRow
                        row={row}
                        key={index}
                        index={index}
                        skipValue={0}
                      />
                    );
                  })
                : null}
            </TableBody>
          </Table>
          {/* <div style={{ marginTop: '20px', textAlign: 'center' }} hidden={survey.length != 0}>
                No data with given filters
            </div> */}
        </TableContainer>
      </Box>
    </div>
  );
}

export default Mentors;
